import React from 'react';

interface PageContainerProps {
  children: React.ReactNode;
  title?: string;
  actionButton?: React.ReactNode;
  userRole?: 'Teacher' | 'SchoolAdmin' | 'SuperAdmin' | 'Student';
}

/**
 * PageContainer - A consistent container for all pages
 * Provides standardized padding, heading structure, and layout for all screens
 */
const PageContainer: React.FC<PageContainerProps> = ({ children, title, actionButton, userRole }) => {
  return (
    <div className="w-full max-w-full flex-grow">
      {title && (
        <div className={`flex justify-between items-center mb-4 ${userRole && userRole !== 'Student' ? 'p-3 rounded-lg bg-gradient-to-r from-primary to-primary-dark' : ''}`}>
          <h1 className={`text-2xl font-bold ${userRole && userRole !== 'Student' ? 'text-white' : 'text-gray-900'}`}>{title}</h1>
          {actionButton && (
            <div className="flex-shrink-0">
              {actionButton}
            </div>
          )}
        </div>
      )}
      {children}
    </div>
  );
};

export default PageContainer;
